export enum SupportEvent {
  // tasks
  TASK_ASSIGNED = 'SUPPORT_TASK_ASSIGNED',
  TASK_COMPLETED = 'SUPPORT_TASK_COMPLETED',
  TASK_OPENED = 'SUPPORT_TASK_OPENED',
  TASK_REMINDER_SET = 'SUPPORT_TASK_REMINDER_SET',
  // messages
  MESSAGE_CREATED = 'SUPPORT_MESSAGE_CREATED',
  MESSAGE_RECEIVED = 'SUPPORT_MESSAGE_RECEIVED',
}
